import { render, staticRenderFns } from "./ReportCardBigNumber.vue?vue&type=template&id=26053783&scoped=true"
import script from "./ReportCardBigNumber.vue?vue&type=script&lang=ts"
export * from "./ReportCardBigNumber.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardBigNumber.vue?vue&type=style&index=0&id=26053783&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26053783",
  null
  
)

export default component.exports